import React from 'react';
import { Button } from '@planne-software/uni';
import { Stack } from '@planne-software/uni/mui/material';
import { IconLayoutGridAdd, IconPlus } from '@planne-software/uni/icons';

import { useTranslate } from '@src/core/hooks';
import type { SaleAdditional } from '@src/domains/sale-items';

import { ReservationChip, ReservationChipList, ReservationRow, ReservationRowText } from '../styles';

type ReservationAdditionalsRowProps = {
  additionals: SaleAdditional[];
  overflowCount: number;
  overflowAs: 'chip' | 'link';
  onShowAll: () => void;
};

export const ReservationAdditionalsRow = (props: ReservationAdditionalsRowProps) => {
  const { additionals, overflowCount, overflowAs, onShowAll } = props;
  const { i18n } = useTranslate();

  if (!additionals.length) {
    return null;
  }

  return (
    <>
      <ReservationRow data-testid='reservation-additionals'>
        <IconLayoutGridAdd size={20} aria-hidden />
        <ReservationRowText>{i18n('checkout_confirmed_additionals')}</ReservationRowText>
      </ReservationRow>

      <ReservationChipList>
        {additionals.map((saleAdditional) => (
          <ReservationChip key={saleAdditional.id} label={saleAdditional.additional.title} />
        ))}

        {overflowCount > 0 && overflowAs === 'chip' ? (
          <ReservationChip
            data-testid='reservation-additionals-overflow'
            clickable
            onClick={onShowAll}
            label={i18n('checkout_confirmed_additionals_overflow', { count: overflowCount })}
          />
        ) : null}
      </ReservationChipList>

      {overflowCount > 0 && overflowAs === 'link' ? (
        <Stack sx={{ width: '100%', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <Button
            data-testid='reservation-additionals-overflow'
            variant='slim'
            color='neutral'
            startSlot={<IconPlus aria-hidden />}
            onClick={onShowAll}
          >
            {i18n('checkout_confirmed_additionals_show_more')}
          </Button>
        </Stack>
      ) : null}
    </>
  );
};

export default ReservationAdditionalsRow;
